import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'

// 引入自定义验证指令
import elValidate from '@/directives/elValidate'
Vue.directive('el-validate', elValidate)

import NavHeader from '@/components/NavHeader'
import NavAside from '@/components/NavAside'
import Breadcrumb from '@/components/Breadcrumb'
import SearchBox from '@/components/SearchBox'
import Pagination from '@/components/Pagination'
import CommonForm from '@/components/CommonForm'
import CommonTable from '@/components/CommonTable'

// import {
//   Button,
//   Card,
//   Form,
//   FormItem,
//   Input,
//   Container,
//   Header,
//   Main,
//   Menu,
//   MenuItem,
//   Icon
// } from 'element-ui'

// Vue.component(Button.name, Button)
// Vue.component(Card.name, Card)
// Vue.component(Form.name, Form)
// Vue.component(FormItem.name, FormItem)
// Vue.component(Input.name, Input)
// Vue.component(Container.name, Container)
// Vue.component(Header.name, Header)
// Vue.component(Main.name, Main)
// Vue.component(Menu.name, Menu)
// Vue.component(MenuItem.name, MenuItem)
// Vue.component(Icon.name, Icon)

import ElementUI from 'element-ui'
import './style/element-variables.scss'
Vue.use(ElementUI)

Vue.component(NavHeader.name, NavHeader)
Vue.component(NavAside.name, NavAside)
Vue.component(Breadcrumb.name, Breadcrumb)
Vue.component(SearchBox.name, SearchBox)
Vue.component(Pagination.name, Pagination)
Vue.component(CommonForm.name, CommonForm)
Vue.component(CommonTable.name, CommonTable)

// 金额千分符过滤器
Vue.filter('moneyFormat', function (value) {
  if (value === null || value === undefined || value === '') return '0.00'
  let val = parseFloat(value)
  if (isNaN(val)) return value
  return val.toLocaleString('zh-CN', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })
})

Vue.config.productionTip = false

Vue.prototype.$http = axios

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
